import React from 'react'
import { InputNumberProps, DatePickerProps, SelectProps } from 'antd'

/**
 * 匹配类型枚举
 */
export enum MatchType {
  /** 等于 */
  EQUAL = 'equal',
  /** 模糊匹配 */
  LIKE = 'like',
  /** 不等于 */
  NOT_EQUAL = 'notEqual',
  /** 大于 */
  GREATER_THAN = 'gt',
  /** 大于等于 */
  GREATER_THAN_OR_EQUAL = 'ge',
  /** 小于 */
  LESS_THAN = 'lt',
  /** 小于等于 */
  LESS_THAN_OR_EQUAL = 'le',
  /** 包含 */
  IN = 'in',
  /** 不包含 */
  NOT_IN = 'notIn',
}

/**
 * 匹配类型选项
 */
export const MATCH_TYPE_OPTIONS = [
  { label: '等于', value: MatchType.EQUAL },
  { label: '模糊匹配', value: MatchType.LIKE },
  { label: '不等于', value: MatchType.NOT_EQUAL },
  { label: '大于', value: MatchType.GREATER_THAN },
  { label: '大于等于', value: MatchType.GREATER_THAN_OR_EQUAL },
  { label: '小于', value: MatchType.LESS_THAN },
  { label: '小于等于', value: MatchType.LESS_THAN_OR_EQUAL },
  { label: '包含', value: MatchType.IN },
  { label: '不包含', value: MatchType.NOT_IN },
]

/**
 * 字段值类型
 */
export type FieldValueType = 'string' | 'number' | 'date' | 'dateRange' | 'select' | 'selectMultiple'

/**
 * 选择项配置
 */
export interface SelectOption {
  /** 选项值 */
  value: string | number
  /** 选项标签 */
  label: string
  /** 是否禁用 */
  disabled?: boolean
}

/**
 * 筛选字段配置
 */
export interface FilterField {
  /** 字段标识 */
  key: string
  /** 字段显示名称 */
  label: string
  /** 字段值类型 */
  valueType?: FieldValueType
  /** 输入组件占位符 */
  placeholder?: string
  /** 数字输入框配置（当valueType为number时） */
  inputNumberProps?: InputNumberProps
  /** 日期选择器配置（当valueType为date或dateRange时） */
  datePickerProps?: DatePickerProps
  /** 选择项数组（当valueType为select或selectMultiple时） */
  options?: SelectOption[]
  /** 是否禁用 */
  disabled?: boolean
}

/**
 * 筛选条件项
 */
export interface FilterCondition {
  /** 字段标识 */
  field: string
  /** 匹配类型 */
  matchType: MatchType
  /** 字段值 */
  value: string | number | [string, string] | (string | number)[] | null
}

/**
 * 筛选弹窗组件属性
 */
export interface FilterModalProps {
  /** 是否显示弹窗 */
  visible: boolean
  /** 弹窗显示/隐藏回调 */
  onVisibleChange: (visible: boolean) => void
  /** 弹窗标题 */
  title?: string
  /** 筛选字段配置列表 */
  fields: FilterField[]
  /** 搜索回调函数 */
  onSearch: (conditions: FilterCondition[]) => void
  /** 重置回调函数（可选） */
  onReset?: () => void
  /** 弹窗宽度 */
  width?: number
  /** 是否显示重置按钮 */
  showReset?: boolean
  /** 搜索按钮文本 */
  searchText?: string
  /** 重置按钮文本 */
  resetText?: string
  /** 取消按钮文本 */
  cancelText?: string
}
